__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "_vk_cloud_account_host";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@vk-tech-solar/config", "0.97.16", () => (Promise.all([__webpack_require__.e(896), __webpack_require__.e(798)]).then(() => (() => (__webpack_require__(3798))))));
			register("@vk-tech-solar/core", "0.97.16", () => (Promise.all([__webpack_require__.e(896), __webpack_require__.e(524)]).then(() => (() => (__webpack_require__(8524))))));
			register("@vk-tech-solar/dev-tools-utils", "0.97.16", () => (Promise.all([__webpack_require__.e(71), __webpack_require__.e(486), __webpack_require__.e(435), __webpack_require__.e(1), __webpack_require__.e(987)]).then(() => (() => (__webpack_require__(9486))))));
			register("lodash", "4.18.1", () => (__webpack_require__.e(377).then(() => (() => (__webpack_require__(4377))))));
			register("mobx", "6.15.0", () => (__webpack_require__.e(420).then(() => (() => (__webpack_require__(4420))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};